import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderProgressTutorials extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
        this.cssClasses = {
            resourceTaxa: '-fs16',
            resourceWrapper: '-mb3',
            titleWrapper: '-fs18 -mb0'
        }
    }

    getItemHtml(item, relatedMedia) {
        let { resourceTaxa, resourceWrapper, titleWrapper} = this.cssClasses;
        let resourceUrl = '';
        let dciInterfaces = item.prgsUniversalTaxonomy.filter(p => p.ParentId == 'b1f75384-863f-4a10-b545-3072b619ba1a');
        const { Title, UrlName: resourcePath } = item;
        let pageUrl = "/tutorials/";
        if(dciInterfaces.length > 0) {
            pageUrl += dciInterfaces[0].UrlName;
        }
        resourceUrl = `${pageUrl}/${resourcePath}`;

        let html = `
        <li class="${resourceWrapper}">
            <div class="${titleWrapper}">
                <a href="${resourceUrl}">${this.encodeHtml(Title)}</a>
            </div>
            <span class="${resourceTaxa}">`
        ;

        for (let i = 0; i < dciInterfaces.length; i++) {
            html += dciInterfaces[i].Title;
            if (i < dciInterfaces.length - 1) {
                html += ', ';
            }
        }
        
        html += '</span></li>';

        return html;
    }
}
